<template>
  <div class="right-nav" v-if="navList && navList.length">
    <ul class="list">
      <li class="title">{{title}}</li>
      <li @click="itemClick(item)" :class="{'actived':item.id == selectItem.id}" v-for="(item, index) in navList">
        <div class="txt">
          {{item.name}}
        </div>
      </li>
    </ul>
    <slot name="right">
    </slot>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import Vue from 'vue'
import util from 'libs/util'
import helpers from 'dom-helpers';

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    selected: {
      type: Object,
      default () {
        return {}
      }
    },
    navList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    selected(newVal, oldVal) {
      if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
        this.selectItem = newVal;
      }
    }
  },
  data() {
    return {
      selectItem: this.selected || {}
    }
  },
  methods: {
    itemClick(item) {
      this.$emit('itemClick', item);
    }
  }
}

</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';
.right-nav {
  width: 118px;
  border-radius:8px 0px 0px 8px;
  .list {
    border-radius: 8px 0px 0px 8px;
    border: 1px solid #ECECEC;
    padding-bottom: 20px;
    background: #fff;
    li {
      height: 44px;
      line-height: 44px;
      padding: 0 10px;
      font-size: 16px;
      color: #666666;
      text-align: center;
      border-bottom: solid 1px #F0F0F0;
      cursor: pointer;
      &.title {
        color: #999;
        height: 57px;
        line-height: 57px;
        cursor: default;
        font-size: 14px;
      }
      &.actived {
        background: #E5FFE5;
        color: #57AE59;
        font-weight: bold;
        border: solid 1px #57AE59;
        border-right: 0;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          top: 50%;
          left: -13px;
          width: 0;
          height: 0;
          transform: translate(0, -50%);
          border-width: 6px;
          border-style: solid;
          border-color: transparent #57AE59 transparent transparent;
          z-index: 1;
        }
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: -15px;
          width: 0;
          height: 0;
          transform: translate(0, -50%);
          border-width: 10px;
          border-style: solid;
          border-color: transparent #E5FFE5 transparent transparent;
          z-index: 2;
        }
      }
      .txt {
        .overflow(1)
      }
    }
  }
}

</style>
